import { useCallback, useEffect, useState } from "react";
import Breadcrumbs from "../../../components/breadcrumbs/Breadcrumbs";
import { DynamicFilterConfig } from "../../../components/DynamicComponent/DynamicFilterPanel";
import GridTable from "../../../components/GridTable/GridTable";
import endpoints from "../../../services/endpoints";
import { Link, useNavigate, useLocation } from "react-router";
import { setListOfUsers } from "../../../store/slices/selectedBankIdSlice";
import { useDispatch } from "react-redux";

export default function ListOfReversals() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { etopUpReversals, mnoList } = endpoints;
    const [searchPlaceholder, setSearchPlaceholder] = useState<string>('transaction id');
    const [isTransitioning, setIsTransitioning] = useState<boolean>(false);
    const [fetchListTrigger, setFetchListTrigger] = useState<boolean>(false);
  const etopupTableDetails: { [key: string]: any } = {
    "Transaction ID": {
      id: "transaction_id",
    },
    "Reversal Date and Time": {
      id: "reversal_date",
      custom: ["reversal_date"],
    },
    Description: {
      id: "reversal_description",
      custom: ["reversal_description"],
    },
    Amount: {
      id: "amount",
      custom: ["amount"],
    },
  };
  const rechargeTableDetails: { [key: string]: any } = {
    "MNO Name": {
      id: "name",
      // custom: ["mno_name"],
    },
    "eTop Up Running Balance": {
      id: "etopup_balance",
      custom: ["etopup_balance"],
    },
    "Bundle Running Balance": {
      id: "bundle_balance",
      custom: ["bundle_balance"],
    },
    Actions: {
      id: "actions",
      actionTypes: ["view"],
    },
    
  };

  const handleActions = async (id: string, key: string, text?: any) => {
    dispatch(setListOfUsers(location.pathname + location.search))
    navigate(`/zoodpay-money/reversals/recharge-reversal/${id}`);
  };
  const staticText = {
    emptyScreenText: {
      heading1: "No Data",
      heading2: "No records found.",
    },
  };
  const dynamicFilterConfig: DynamicFilterConfig = {
    "Date Range": {
      label: "Date Range",
      type: "date",
      required: false,
      searchKey: {
        start: "reversal_start_date",
        end: "reversal_end_date",
      },
    },
  }
  const SEARCH_PLACEHOLDERS = [
    'user name',
    'user code',
    'transaction id',
  ] as const;
  
  const currentPath = location.pathname;
  const isRechargeReversal = currentPath.includes('/recharge-reversal');
  const isEtopupReversal = currentPath.includes('/etopup-reversal');
  const isDigitalWalletReversal = currentPath.includes('/digital-wallet-reversal') || currentPath === '/zoodpay-money/reversals';
  
  // Trigger API call when tab changes
  useEffect(() => {
    setFetchListTrigger(prev => !prev);
  }, [isRechargeReversal, isEtopupReversal, isDigitalWalletReversal]);
  
  const renderExtraHeading = () => {
    return (
      <div className="flex flex-row gap-6 pt-6 pb-3 pl-4">
        <div className={`text-subTitle ${isRechargeReversal ? 'text-p_primary border-b-2 border-p_primary' : 'text-gray-400 border-b-2 border-gray-400'}`}>
          <Link
            to={"/zoodpay-money/reversals/recharge-reversal"}
          >
            Recharge Reversal
          </Link>
        </div>
        <div className={`text-subTitle ${isEtopupReversal ? 'text-p_primary border-b-2 border-p_primary' : 'text-gray-400 border-b-2 border-gray-400'}`}>
          <Link
            to={"/zoodpay-money/reversals/etopup-reversal"}
          >
            eTop Up Stock Reversal
          </Link>
        </div>
        <div className={`text-subTitle cursor-not-allowed ${isDigitalWalletReversal ? 'text-p_primary border-b-2 border-p_primary' : 'text-gray-400 border-b-2 border-gray-400'}`}>
          <span>
            Digital Wallet Reversal
          </span>
        </div>
      </div>
    );
  };

  const addButtonClick = () => {
    dispatch(setListOfUsers(location.pathname + location.search))
    navigate("/zoodpay-money/reversals/recharge-reversal/add-reversal");
  };

  const rotatePlaceholder = useCallback(() => {
    setIsTransitioning(true);

    setTimeout(() => {
      setSearchPlaceholder(prev => {
        const currentIndex = SEARCH_PLACEHOLDERS.indexOf(prev as typeof SEARCH_PLACEHOLDERS[number]);
        const nextIndex = (currentIndex + 1) % SEARCH_PLACEHOLDERS.length; // Loop cyclically
        return SEARCH_PLACEHOLDERS[nextIndex];
      });
      setIsTransitioning(false);
    }, 500);
  }, []);

  useEffect(() => {
    const interval = setInterval(rotatePlaceholder, 2500);
    return () => clearInterval(interval);
  }, [rotatePlaceholder]);  return (
    <>
      <Breadcrumbs
        navPath={["Zoodpay Money", "Reversals", `List of Reversals`]}
        heading={`List of Reversals`}
        noNavigation={true}
        list={true}
        button={isRechargeReversal && {
          buttonName: "Add Reversal",
          className: "w-[140px]",
          buttonOnclick: addButtonClick,
        }}
      />
      <GridTable
        staticText={staticText}
        mainEndPoint={isRechargeReversal ? mnoList : etopUpReversals}
        TableDetails={
          isRechargeReversal ? rechargeTableDetails : etopupTableDetails
        }
        handleActions={(id: string, key: string, text?: string) =>
          handleActions(id, key, text)
        }
        params={{ page_number: "1" }}
        searchPlaceholder={`Search by ${
          isRechargeReversal ? "mno name" : "transaction id"
        }`}
        filters={isRechargeReversal ? false : true}
        extraParams={isRechargeReversal ? "&type=reversal" : ""}
        exporting={true}
        reportType="Balance Sheet"
        notfoundRoute={{
          state: { route: `/zoodpay-money/reversals/recharge-reversal` },
        }}
        title={`List of Reversals`}
        hasViewMDPrivilege={true}
        addMorePadding={false}
        dynamicFilterConfig={dynamicFilterConfig}
        heightClassName="h-reversalsHeight"
        renderExtraHeading={renderExtraHeading}
        fetchListTrigger={fetchListTrigger}
        filterShimmer={true}
        customHeight="h-[103px]"
        extraExportParams={isRechargeReversal ? { type: "reversal" } : undefined}
        forceFullWidth={true}
      />
    </>
  );
}
